import { Column, ColumnMeta } from '@tanstack/react-table';
import { DebouncedSearch } from './DebouncedSearch';
import { ComponentProps } from 'react';
import { FilterButton } from 'components/filter-button/FilterButton';
import styles from './filters.module.css';

export const Filter = ({
    column,
    filter,
    isDisabled,
}: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    column: Column<any>;
    filter: NonNullable<ColumnMeta<unknown, unknown>['filter']>;
    isDisabled: ComponentProps<typeof DebouncedSearch>['disabled'];
}) => {
    const columnFilterValue = column.getFilterValue();
    // support other filter types in the future
    if (filter.search) {
        return (
            <DebouncedSearch
                onChange={value => column.setFilterValue(value)}
                placeholder={filter.search.placeholder}
                value={(columnFilterValue ?? '') as string}
                disabled={isDisabled}
                debounce={filter.search.debounce}
                type={filter.search.type}
            />
        );
    }
    if (filter.button) {
        // Get all of the row values for this column, unique them, and sort them
        const data = Array.from(
            new Set(column.getFacetedRowModel().rows.map(row => row.getValue(column.id)))
        ).sort() as string[];
        return (
            <FilterButton
                data={data}
                onChange={value => column.setFilterValue(value)}
                value={(columnFilterValue ?? []) as string[]}
                disabled={isDisabled}
                comboboxProps={{ width: 'max-content', portalProps: { className: styles.filterbutton } }}
                {...filter.button}
            />
        );
    }

    return null;
};
